import i18n from "services/i18n";

/**
 * Whole units by default, where Intl defaults to two: prices in the app carry no cents.
 * Currency codes come from API data, and Intl throws rather than degrades on an invalid one.
 */
export function formatMoney(
  amount: number,
  currency: string,
  options?: Intl.NumberFormatOptions
): string {
  try {
    return new Intl.NumberFormat(i18n.language, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      ...options,
    }).format(amount);
  } catch {
    return `${amount} ${currency}`;
  }
}
